// @flow strict

export const LibraryNamespace: string = 'geniussports'

export default function addEntry<E> (entryName: string, Entry: E): E {
  // $FlowFixMe
  if (WITH_WINDOW_EXPORT && typeof window !== 'undefined') {
    if (!window[LibraryNamespace]) {
      window[LibraryNamespace] = {}
    }
    if (!window[LibraryNamespace][entryName]) {
      window[LibraryNamespace][entryName] = Entry
    }
  }
  return Entry
}



// WEBPACK FOOTER //
// ./src/main/javascript/addEntry.js